import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
// import { ModalModule } from 'ngx-bootstrap/modal';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';

import { withInMemoryScrolling } from '@angular/router';


export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes ,withInMemoryScrolling()), provideClientHydration(),
     provideAnimationsAsync(),provideHttpClient(withFetch()),
    //  importProvidersFrom(ModalModule.forRoot())
    ]
};
